module.exports = __webpack_public_path__ + "statics/img/18.f612a10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/18.png
// module id = EmQx
// module chunks = 1